import { useState } from 'react';

import type { TView } from '@shared/types/view';
import type { Updater, VisibilityState } from '@tanstack/react-table';
import { removeNullishFromObj } from '@src/shared/utils/helpers/remove-nullish-from-obj';

export const useColumnVisibility = (view?: TView) => {
  const [columnVisibility, setColumnVisibility] = useState(
    view?.visible_static_fields.visibility || {}
  );

  const derivedColumnVisibility = Object.keys(columnVisibility || {}).length
    ? columnVisibility
    : view?.visible_static_fields.visibility || {};

  function onColumnVisibilityChange(updaterOrValue: Updater<VisibilityState>) {
    if (typeof updaterOrValue === 'function') {
      const col = updaterOrValue(derivedColumnVisibility);
      setColumnVisibility(col);
    } else {
      setColumnVisibility(updaterOrValue);
    }
  }

  const isColumnVisibilityChanged =
    Object.keys(removeNullishFromObj(derivedColumnVisibility, ['true']) || {})
      .length !==
    Object.keys(
      removeNullishFromObj(view?.visible_static_fields.visibility, ['true']) ||
        {}
    ).length;

  return {
    columnVisibility: removeNullishFromObj<VisibilityState>(
      derivedColumnVisibility,
      ['true']
    ),
    onColumnVisibilityChange,
    isColumnVisibilityChanged,
  };
};
